import React from "react";
import classNames from "classnames";
import { BemHelper } from "../../utils/BemHelper";
import { CriyaDarkLogo } from "../logos/CriyaDarkLogo";
import { CriyaShortDarkLogo } from "../logos/CriyaShortDarkLogo";

type Props = {
  children: React.ReactNode;
  collapsed: boolean;
};

const bem = new BemHelper("sidebar");

export const Sidebar: React.FC<Props> = ({ children, collapsed }) => {
  return (
    <div className={classNames(bem.block())}>
      <div className={classNames(bem.element("header"))}>
        {collapsed ? <CriyaShortDarkLogo /> : <CriyaDarkLogo />}
      </div>
      <div className={classNames(bem.element("options"))}>{children}</div>
    </div>
  );
};
